import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { logout } from "../../common/helpers/auth";

export class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      classesList: [],
    };
  }

  componentDidMount = () => {
    if (localStorage.getItem("roleType") === "30") {
      logout();
      localStorage.clear();
      window.location = "#/";
      window.location.reload();
    }

    this.getTodaysClasses();
  };

  getTodaysClasses = async () => {
    this.setState({ loaded: false });

    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.userId = localStorage.getItem("userId");

    await api("bookApiV1BookGetByTodaysDate", bookRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.bookList)) {
          res.data.bookList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState({
            classesList: bookResponse.bookList,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Classes could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookGetByTodaysDate has failed");
      }
    });

    this.setState({ loaded: true });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <div className="ui-g-12">
          <div
            className="ui-g-12 ui-md-6 ui-lg-4"
            onClick={() => {
              window.location = "/#/clients";
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <div className="ui-g card colorbox colorbox-1">
              <div className="ui-g-4">
                <i className="material-icons">people</i>
              </div>
              <div className="ui-g-8">
                <span className="colorbox-name" />
                <span className="colorbox-count">Clients</span>
              </div>
            </div>
          </div>
          <div
            className="ui-g-12 ui-md-6 ui-lg-4"
            onClick={() => {
              window.location = "/#/employees";
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <div className="ui-g card colorbox colorbox-2">
              <div className="ui-g-4">
                <i className="material-icons">people_outline</i>
              </div>
              <div className="ui-g-8">
                <span className="colorbox-name" />
                <span className="colorbox-count">Employees</span>
              </div>
            </div>
          </div>
          <div
            className="ui-g-12 ui-md-6 ui-lg-4"
            onClick={() => {
              window.location = "/#/classes";
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <div className="ui-g card colorbox colorbox-3">
              <div className="ui-g-4">
                <i className="material-icons">accessibility</i>
              </div>
              <div className="ui-g-8">
                <span className="colorbox-name" />
                <span className="colorbox-count">Classes</span>
              </div>
            </div>
          </div>
        </div>

        {!this.state.loaded ? (
          <div className="ui-g-12">
            <center>
              <pr.Growl
                style={{ textAlign: "left" }}
                ref={(el) => (this.growl = el)}
              />
              <LoadScreen />
            </center>
          </div>
        ) : (
          <div className="ui-g-12">
            <pr.Growl
              style={{ textAlign: "left" }}
              ref={(el) => (this.growl = el)}
            />
            <pr.DataTable
              value={this.state.classesList}
              selectionMode="single"
              onSelectionChange={() => {}}
              header="Today's Classes"
              autoLayout={true}
              paginator={true}
              alwaysShowPaginator={true}
              rows={10}
              emptyMessage="No classes today"
            >
              <pr.Column
                field="level"
                header="Class"
                sortable={true}
                filter={true}
                style={{ overflow: "auto" }}
              />
              <pr.Column
                field="instructor"
                header="Instructor"
                body={(e) => {
                  let instructorArray = [];
                  let i = 0;

                  if (e.instructorDetails !== undefined) {
                    e.instructorDetails.forEach((f) => {
                      instructorArray[i] = <li key={i}>{f.firstName}</li>;
                      i++;
                    });
                  }

                  return instructorArray;
                }}
                sortable={false}
                filter={false}
                style={{ overflow: "auto" }}
              />
              <pr.Column
                field="roomDetails.roomName"
                header="Room"
                body={(e) => {
                  if (e.roomDetails === undefined) {
                    return "";
                  }
                  return e.roomDetails.roomName;
                }}
                sortable={false}
                filter={false}
                style={{ overflow: "auto" }}
              />
              <pr.Column
                field="startTime"
                header="Start Time"
                sortable={true}
                filter={true}
                style={{ overflow: "auto" }}
              />
              <pr.Column
                field="endTime"
                header="Finish Time"
                sortable={true}
                filter={true}
                style={{ overflow: "auto" }}
              />
            </pr.DataTable>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js